module.exports = __webpack_public_path__ + "static/media/adv-2.6b5ccd85.png";